import { useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import { makeStyles } from "@material-ui/core";
import { Paper, Typography, Fade } from "@material-ui/core";
import DOMPurify from "dompurify";

const useStyles = makeStyles((theme) => ({
	paper: {
		padding: "1rem",
	},
}));

function WhatIs() {
	const classes = useStyles();
	const { selectedSite } = useContext(SiteContext);
	return (
		<Fade in={typeof selectedSite != undefined}>
			<Paper className={classes.paper}>
				<Typography component="span" variant="h6">
					What is {selectedSite && selectedSite.name}?
				</Typography>
				<Typography
					dangerouslySetInnerHTML={{
						__html: DOMPurify.sanitize(
							selectedSite && selectedSite.description
						),
					}}
				></Typography>
			</Paper>
		</Fade>
	);
}

export default WhatIs;
